module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content) ? _c('div', {
    class: ['trial-strip', _vm.content.tone],
    style: (_vm.offsetTop ? {
      top: _vm.offsetTop + 'px'
    } : null)
  }, [_c('div', {
    staticClass: "trial-strip-left"
  }, [_c('svg', {
    staticClass: "trial-strip-icon",
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [(_vm.content.tone === 'expired') ? [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })] : (_vm.content.tone === 'past-due') ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })] : (_vm.content.tone === 'red') ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })] : (_vm.content.ctaAction === 'resend-verification') ? [_c('path', {
    attrs: {
      "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "22,6 12,13 2,6"
    }
  })] : [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "12 6 12 12 16 14"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "trial-strip-body",
    domProps: {
      "innerHTML": _vm._s(_vm.content.messageHtml)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "trial-strip-right"
  }, [_c('button', {
    staticClass: "trial-strip-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCta
    }
  }, [_vm._v("\n      " + _vm._s(_vm.content.ctaLabel) + "\n    ")]), _vm._v(" "), (_vm.content.dismissible) ? _c('button', {
    staticClass: "trial-strip-dismiss",
    attrs: {
      "type": "button",
      "title": "Dismiss"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('dismiss')
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4242752d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/TrialStrip.vue
// module id = 760
// module chunks = 2